import { render, staticRenderFns } from "./BookAppointmentButton.vue?vue&type=template&id=b08383ea&scoped=true&"
import script from "./BookAppointmentButton.vue?vue&type=script&lang=js&"
export * from "./BookAppointmentButton.vue?vue&type=script&lang=js&"
import style0 from "./BookAppointmentButton.vue?vue&type=style&index=0&id=b08383ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08383ea",
  null
  
)

export default component.exports